import React from 'react';

import Html from 'views/components/html';
import Header from 'views/components/header';
import HeroImage from 'views/components/hero-image';
import Body from 'views/components/body';
import Contents from 'views/components/contents';
import Footer from 'views/components/footer';
import { Slogan } from './index.styled';

const Home = () => {
  return (
    <>
      <Html />
      <Header />
      <HeroImage>
        <Body>
          <Contents>
            <Slogan>
              <div>
                <div>最高の技術で、</div>
                <div>最高のプラスチック製品を。</div>
              </div>
              <div>
                <div>常にお客様に喜んでいただくため、</div>
                <div>あらゆる樹脂材料を取り扱ってきました。</div>
                <div>高品質な透明成形、肉厚成形もお任せください。</div>
              </div>
            </Slogan>
          </Contents>
        </Body>
      </HeroImage>
      <Footer />
    </>
  );
};

export default Home;
